import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Copy, Flex, Button } from '@elparking/components'

const RegisterOnMobileButton = ({ onClick }) => (
  <Flex flexWrap="wrap" mt="8px" w="100%" justifyContent="center">
    <Button.unstyled padding="8px 0 24px 0" align="center" onClick={onClick}>
      <Copy
        as="a"
        fontColor="main"
        decoration="none"
        fontWeight="medium"
        fontSize="small"
        transform="none"
      >
        <FormattedMessage defaultMessage="¿No tienes cuenta?" />
      </Copy>
    </Button.unstyled>
  </Flex>
)
RegisterOnMobileButton.propTypes = {
  onClick: PropTypes.func,
}

export default RegisterOnMobileButton
